import React from "react";
import { ModeRendererProps } from "./types";

// VASARELY × DEGAS: Discipline in motion — ballet of form and code
// Graceful arcs, warm neutrals, motion frames
export function VasarelyDegasMode({ brand }: ModeRendererProps) {
  return (
    <g>
      {/* Soft rehearsal space background */}
      <rect x="0" y="0" width="794" height="1123" fill="#2A2520" opacity="0.9" />

      <g transform="translate(397 540)">
        {/* Graceful arc trajectories */}
        {Array.from({ length: 8 }).map((_, i) => {
          const startAngle = -90 + i * 22.5;
          const startRad = (startAngle * Math.PI) / 180;
          const r = 200;
          
          return (
            <path
              key={i}
              d={`M ${Math.cos(startRad) * r} ${Math.sin(startRad) * r} Q 0 ${-r / 2} ${Math.cos(startRad + 1) * r} ${Math.sin(startRad + 1) * r}`}
              fill="none"
              stroke={i % 2 === 0 ? "#D4A574" : brand.aqua}
              strokeWidth="2"
              opacity="0.4"
            />
          );
        })}

        {/* Motion frame grid (choreography structure) */}
        {Array.from({ length: 12 }).map((_, i) =>
          Array.from({ length: 16 }).map((_, j) => {
            const x = (i - 5.5) * 45;
            const y = (j - 7.5) * 42;
            const motion = Math.sin(i * 0.4 + j * 0.3) * 8;
            
            return (
              <rect
                key={`${i}-${j}`}
                x={x - 16 + motion}
                y={y - 16}
                width="32"
                height="32"
                fill="#D4A574"
                opacity={0.12}
              />
            );
          })
        )}

        {/* Ballet positions (geometric poses) */}
        {[
          { x: -140, y: -120, angle: -25 },
          { x: 0, y: -150, angle: 0 },
          { x: 140, y: -110, angle: 25 },
          { x: -100, y: 100, angle: -15 },
          { x: 120, y: 110, angle: 15 },
        ].map((pose, i) => (
          <g key={i}>
            <ellipse
              cx={pose.x}
              cy={pose.y}
              rx="40"
              ry="60"
              fill={brand.aqua}
              opacity="0.2"
              transform={`rotate(${pose.angle} ${pose.x} ${pose.y})`}
            />
            <ellipse
              cx={pose.x}
              cy={pose.y - 25}
              rx="20"
              ry="20"
              fill="#D4A574"
              opacity="0.3"
            />
            {/* Arms */}
            <line
              x1={pose.x - 35}
              y1={pose.y - 10}
              x2={pose.x + 35}
              y2={pose.y - 10}
              stroke={brand.violet}
              strokeWidth="3"
              opacity="0.4"
            />
            {/* Legs */}
            <line
              x1={pose.x}
              y1={pose.y + 30}
              x2={pose.x - 20}
              y2={pose.y + 70}
              stroke={brand.violet}
              strokeWidth="3"
              opacity="0.4"
            />
            <line
              x1={pose.x}
              y1={pose.y + 30}
              x2={pose.x + 20}
              y2={pose.y + 70}
              stroke={brand.violet}
              strokeWidth="3"
              opacity="0.4"
            />
          </g>
        ))}

        {/* Discipline lines (practice bar metaphor) */}
        <line x1="-280" y1="-100" x2="280" y2="-100" stroke="#D4A574" strokeWidth="4" opacity="0.5" />
        <line x1="-280" y1="150" x2="280" y2="150" stroke="#D4A574" strokeWidth="4" opacity="0.5" />

        {/* Optical movement trails */}
        {Array.from({ length: 20 }).map((_, i) => {
          const angle = (i * Math.PI) / 10;
          const r1 = 100;
          const r2 = 180;
          
          return (
            <line
              key={i}
              x1={Math.cos(angle) * r1}
              y1={Math.sin(angle) * r1}
              x2={Math.cos(angle) * r2}
              y2={Math.sin(angle) * r2}
              stroke={brand.aqua}
              strokeWidth="1"
              opacity="0.2"
              strokeDasharray="4 4"
            />
          );
        })}

        {/* Circular choreography marks */}
        {Array.from({ length: 12 }).map((_, i) => {
          const r = 60 + i * 20;
          return (
            <circle
              key={i}
              cx="0"
              cy="0"
              r={r}
              fill="none"
              stroke={i % 2 === 0 ? "#D4A574" : brand.aqua}
              strokeWidth="1"
              opacity={0.2 - i * 0.01}
            />
          );
        })}

        {/* Warm studio frame */}
        <rect x="-240" y="-220" width="480" height="440" fill="none" stroke="#D4A574" strokeWidth="2" opacity="0.4" />
      </g>

      {/* Ballet note */}
      <text x="397" y="1010" textAnchor="middle" fontFamily="serif" fontSize="11" fill="#D4A574" opacity="0.6" fontStyle="italic">
        discipline en mouvement
      </text>
    </g>
  );
}
